/**
 * ScrollToTop Component
 * Scrolls to top of page on every route change.
 * Mount once inside the Router, above all routes.
 */

import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export function ScrollToTop() {
  const { pathname } = useLocation()

  // biome-ignore lint/correctness/useExhaustiveDependencies: Dependency triggers scroll on route change, value not used internally
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
